import { getGlobalStates } from "userful-chronos-app-common-js/dist/globalstates/globalStates";
import {
    REQUEST_PROFILE_LIST,
    REQUEST_PROFILE_SET,
    REQUEST_PROFILE_REMOVE,
    REQUEST_NETWORK_STATICROUTE_REMOVE,
    REQUEST_NETWORK_STATICROUTE_ADD,
    REQUEST_NETWORK_NICS,
    REQUEST_CONNECTION_ACTIVATE,
    REQUEST_DHCPD_CONFIG_GET,
    REQUEST_DHCPD_CONFIG_REMOVE,
    REQUEST_DHCPD_CONFIG_SET,
    REQUEST_DHCPD_CONFIG_EDIT,
} from "userful-chronos-app-common-js/dist/message/messageTypeDefinitions/config/networkConfigMsgDefinitions";
import { StringID } from "userful-chronos-app-common-js/dist/models/common";
import {
    DhcpdConfig,
    NetworkConnectionProfile,
    NetworkStaticRouteConfigData,
} from "userful-chronos-app-common-js/dist/models/config/networkConnections";
import "./networkConfigMsgReciever";

// Connections:
export const requestListConnections = () => {
    console.debug("sending REQUEST_PROFILE_LIST");
    getGlobalStates().eventBus.sendMsg(REQUEST_PROFILE_LIST);
};
export const requestSetConnection = (payload: NetworkConnectionProfile) => {
    console.debug("sending REQUEST_PROFILE_SET");
    getGlobalStates().eventBus.sendMsg(REQUEST_PROFILE_SET, payload);
};
export const requestRemoveConnection = (payload: StringID) => {
    console.debug("sending REQUEST_PROFILE_REMOVE");
    getGlobalStates().eventBus.sendMsg(REQUEST_PROFILE_REMOVE, payload);
};
export const requestActivateConnection = (payload: StringID) => {
    console.debug("sending REQUEST_CONNECTION_ACTIVATE");
    getGlobalStates().eventBus.sendMsg(REQUEST_CONNECTION_ACTIVATE, payload);
};

// Static Routes:
export const requestAddStaticRoute = (payload: NetworkStaticRouteConfigData) => {
    console.debug("sending REQUEST_NETWORK_STATICROUTE_ADD");
    getGlobalStates().eventBus.sendMsg(REQUEST_NETWORK_STATICROUTE_ADD, payload);
};
export const requestRemoveStaticRoute = (payload: NetworkStaticRouteConfigData) => {
    console.debug("sending REQUEST_NETWORK_STATICROUTE_REMOVE");
    getGlobalStates().eventBus.sendMsg(REQUEST_NETWORK_STATICROUTE_REMOVE, payload);
};

// DHCP Config:
export const requestGetDHCPD = () => {
    console.debug("sending REQUEST_DHCPD_CONFIG_GET");
    getGlobalStates().eventBus.sendMsg(REQUEST_DHCPD_CONFIG_GET);
};
export const requestSetDHCPD = (payload: StringID) => {
    console.debug("sending REQUEST_DHCPD_CONFIG_SET");
    getGlobalStates().eventBus.sendMsg(REQUEST_DHCPD_CONFIG_SET, payload);
};
export const requestRemoveDHCPD = (payload: StringID) => {
    console.debug("sending REQUEST_DHCPD_CONFIG_REMOVE");
    getGlobalStates().eventBus.sendMsg(REQUEST_DHCPD_CONFIG_REMOVE, payload);
};
export const requestEditDHCPD = (payload: DhcpdConfig) => {
    console.debug("sending REQUEST_DHCPD_CONFIG_EDIT");
    getGlobalStates().eventBus.sendMsg(REQUEST_DHCPD_CONFIG_EDIT, payload);
};

// NIC Config:
export const requestGetNICS = () => {
    console.debug("sending REQUEST_NETWORK_NICS");
    getGlobalStates().eventBus.sendMsg(REQUEST_NETWORK_NICS);
};
